import type { StoryblokContent } from '../storyblok'
import type { Asset, EdgeStyles } from './shared'
import type { AccordionContainerBlock } from './accordion-container-block'

export interface AccordionMediaBlock extends StoryblokContent {
  component: 'accordion-media-block'
  edgeStyle: EdgeStyles
  smallAsset: Asset
  altTextSmall: string
  largeAsset: Asset
  altTextLarge: string
  assetPosition: 'top' | 'left' | 'right'
  accordion: AccordionContainerBlock[]
}


export function normalizeAccordionMediaBlock(blok: AccordionMediaBlock) {
    return {
      smallAsset: blok?.smallAsset.filename,
      altTextSmall: blok?.altTextSmall,
      largeAsset: blok?.largeAsset.filename,
      altTextLarge: blok?.altTextLarge,
      isMediaTop: blok?.assetPosition === 'top',
      isMediaLeft: blok?.assetPosition === 'left',
      isMediaRight: blok?.assetPosition === 'right',
      edgeStyle: blok?.edgeStyle ?? 'none',
      accordion: blok?.accordion,
    }
  }
  